'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './message.routes';

export class MessageComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('appApp.message', [uiRouter])
  .config(routes)
  .component('message', {
    template: require('./message.html'),
    controller: MessageComponent,
    controllerAs: 'messageCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/message/message.component.js